
export enum Filter {
    NO_FILTER = "noFilter",
    LAST_WEEK = "lastWeek",
    LAST_MONTH = "lastMonth",
    LAST_YEAR = "lastYear",
}